// extracted by mini-css-extract-plugin
module.exports = {"demoProfileLink":"Process_demoProfileLink__8kEwK"};